import { Component, OnInit, Input } from '@angular/core';
import { NgbModal, NgbModalConfig, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-success-modal',
  templateUrl: './success-modal.component.html',
  styleUrls: ['./success-modal.component.scss']
})
export class SuccessModalComponent implements OnInit {
  @Input() statusFlag: boolean = true;
  @Input() successMessage: string;
  @Input() profitFlag: boolean = false;
  @Input() topCutOff: boolean = false;
  constructor(public activeModal: NgbActiveModal,) { }

  ngOnInit(): void {
    console.log(this.successMessage)
  }

}
